import React, {Component, Fragment} from 'react';
import {injectIntl} from "react-intl";
import {Link} from "react-router-dom";
import {Button, Row, Col} from 'antd';
import CarouselArrows from "../../components/Carousel";
import Upload from "../../components/Upload";
import {t} from "../../utils/i18n.js";
import Emitter from "../../eventBus";
import {enquireScreen} from "enquire-js";
import {setAccount, setBalance, setLanguage} from "../../actions/app";
import {connect} from "react-redux";

let isMobile;

enquireScreen((b) => {
    isMobile = b;
});

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {}

    connect = () => {
        let {intl, currentAccount} = this.props;
        if (currentAccount) {
            Emitter.emit('showMessageAlert', {status: 'success', message:  'login_already'});
            return;
        } else {
            Emitter.emit('showMessageModal', {source: 'login'});
        }
    }

    render() {
        let {intl} = this.props;
        return (
            <Fragment>
                <div className='' id='home'>
                    <div className="absolute home_bg z-1 top-0 left-0 w-full h-full">

                    </div>
                    {!isMobile && <div className="absolute home_animation top-0 left-0 w-full h-full">
                         <video autoPlay="autoplay" loop="loop" muted="muted" src='animation.mp4' width='100%'
                               height='100%'></video>
                    </div> }

                    <div className='h-112-rem pb-4 md-slogan'>
                        <div className='title'>
                            {t('home_title')}
                        </div>
                        <div className='sub_title'>
                            {t('home_sub_title')}
                        </div>

                        <div className="mt-10">
                            <div><Upload intl={intl}/></div>
                        </div>

                        <div className="z-1000 relative powered_title mt-2-2-rem">
                            {t('powered_by')}&nbsp;
                            <a href='https://www.bittorrent.com/token/bittorrent-file-system/' target='_blank' rel='noreferrer'>
                            BTFS
                            </a>
                            <a href='https://www.bittorrent.com/token/bittorrent-file-system/' target='_blank' rel='noreferrer'>
                            <img className='inline ml-4' alt='btfs' src={require('../../images/btfs.png').default}/>
                            </a>
                        </div>

                    </div>

                    {isMobile && <div className=" main_pic w-full h-full">
                        <img alt='NFThub' src={require('../../images/NFThub.png').default}/>
                    </div>
                    }

                    <div className='gallery mt-14-rem'>
                        {t('gallery')}
                    </div>

                    <div className='_container mt-5-rem md-carousel'>
                        <CarouselArrows/>
                    </div>

                    <div className='_container mt-7-rem'>
                        <Link to="/justin">
                    <div className='justinsnft flex justify-center items-center text-center text-white'>
                        <div className=''>
                            <div className='header'>Justin@BTFS</div>
                            <div className='description'>{t('justins_nft_description')}</div>
                            <div className='arrow'>

                                <i className="fas fa-long-arrow-alt-right"></i>

                            </div>
                        </div>
                    </div>

                        </Link>

                    </div>

                    <div className='guide mt-14-rem' id={'rules'}>
                        {t('user_guide')}
                    </div>

                    <div className='_container mt-5-rem mb-14-rem'>
                        <Row className=''>
                            <Col lg={8} md={8} xs={8} className='m-0'>
                                <div className='m-0 text-center w-26-rem md-step'>
                                    <div className='flex flex-col items-center'>
                                        <img className='step_img' alt='step1' src={require('../../images/icon1@3x_.png').default}/>
                                        <div className='step_title mt-2-5-rem'>{t('step')} 1</div>
                                        <div className='step_description flex  mt-1-rem'>{t('step1_description')}</div>
                                        <div className="m-auto text-center">
                                        <Button type="primary" className=' step_button' onClick={() => {
                                            window.open('https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec')
                                        }}>
                                            {t('download')}
                                        </Button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8} md={8} xs={8}>
                                <div className='m-0 text-center w-26-rem md-step'>
                                    <div className='flex flex-col items-center'>
                                        <img className='step_img' alt='step2' src={require('../../images/icon2@3x_.png').default}/>
                                        <div className='step_title mt-2-5-rem'>{t('step')} 2</div>
                                        <div className='step_description flex  mt-1-rem'>{t('step2_description')}</div>
                                        <div className="m-auto text-center">
                                        <Button type="primary" className=' step_button' onClick={() => {
                                            this.connect()
                                        }}>
                                            {t('connect_wallet')}
                                        </Button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col lg={8} md={8} xs={8}>
                                <div className='m-0 text-center w-26-rem md-step'>
                                    <div className='flex flex-col items-center'>
                                        <img className='step_img' alt='step3' src={require('../../images/icon3@3x_.png').default}/>
                                        <div className='step_title mt-2-5-rem'>{t('step')} 3</div>
                                        <div className='step_description  mt-1-rem'>
                                            {t('step3_description_part1')} &nbsp;
                                            <Link to='/files'>'{t('my_files')}'</Link>
                                            &nbsp;
                                            {t('step3_description_part2')}
                                        </div>
                                        <div className=' step'>
                                            <Upload intl={intl}/>
                                        </div>

                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>



                    {/*
                <div className="flex justify-center">
                    <Card hoverable style={{width: 340}}>
                        <div className='flex' style={{marginBottom: 16}}>
                            <Input defaultValue="email"/>
                            <Button type="primary" onClick={() => {
                                subscribe()
                            }}>Subscribe</Button>
                        </div>
                    </Card>
                </div>
                */}

                </div>

            </Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        currentAccount: state.app.currentAccount
    };
}

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Home));